// db.ts
import Dexie, {Table} from "dexie";
import type {PantheonSessionStatus} from "../helpers/PantheonSessionHelper";
import {PantheonINI} from "../API";
import {UserQuery} from "../graphql-types";

export interface PantheonSessionDuration {
    startedAt: Date;
    endedAt: Date;
}

export type PantheonNativeProcessState =
    | "starting"
    | "running"
    | "finished"
    | "error"
    | "missing";

export interface PantheonExeSession {
    id?: number;
    clientSessionId?: string;
    serverSessionId?: number;
    serverSyncedAt?: Date;
    companyId?: number;
    ticketId?: number;
    startedAt: Date;
    endedAt?: Date;
    currentStatus?: PantheonSessionStatus;
    pantheonIni: PantheonINI;
    pantheonIniId: number;
    pastSessions?: PantheonSessionDuration[];

    nativeProcessId?: number;
    nativeProcessStartedAt?: Date;
    nativeProcessExePath?: string;
    nativeProcessIniPath?: string;
    nativeProcessState?: PantheonNativeProcessState;
    nativeProcessCheckedAt?: Date;
    nativeMeshCentralTunnelId?: string;

    platformOverride?: "win32" | "darwin";
    UserInfo?: UserQuery;
}

export interface EditorDraft {
    key: string;
    content: string;
    savedAt: Date;
}

export class DexieDatabase extends Dexie {
    pantheonExeSessions!: Table<PantheonExeSession>;
    editorDrafts!: Table<EditorDraft, string>;

    constructor() {
        super("dexieDatabase");
        this.version(5).stores({
            pantheonExeSessions:
                "++id, companyId, ticketId, startedAt, endedAt, currentStatus, pantheonIniId, platformOverride",
        });
        this.version(6).stores({
            editorDrafts: "key, savedAt",
        });
    }
}

let db: DexieDatabase | undefined = undefined;

try {
    db = new DexieDatabase();
} catch (e) {
    console.warn(e);
}

export {db};
